/**
 * useUserProfile Hook (Web)
 * Thin wrapper around shared useUserProfile
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import type { BetsType, TimePeriod } from '@parlay-picker/shared/hooks';
import {
  type UseUserProfileResult,
  useUserProfile as useUserProfileShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

// Re-export types for existing consumers
export type { UserProfileData, UseUserProfileResult } from '@parlay-picker/shared/hooks';

export interface UseUserProfileOptions {
  userId?: string;
  displayName?: string;
  timePeriod?: TimePeriod;
  betsType?: BetsType;
}

export function useUserProfile(options: UseUserProfileOptions): UseUserProfileResult {
  const { authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useUserProfileShared({
    httpClient,
    userId: options.userId,
    displayName: options.displayName,
    timePeriod: options.timePeriod,
    betsType: options.betsType,
  });
}
